@if (activeAchievement) {
  <!-- Confetti Canvas (Highest z-index, fixed full-screen) -->
  <canvas #unlockConfettiCanvas class="unlock-confetti-canvas"></canvas>

  <!-- Modal Backdrop -->
  <div
    class="achievement-unlock-backdrop"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="activeAchievement.title + ' achievement unlocked'"
    (click)="onBackdropClick($event)"
    (keydown.escape)="onDismiss()"
  >
    <div
      class="achievement-unlock-card"
      [ngClass]="categoryThemeKey + ' tier-' + tier.key"
    >
      <!-- Top Close Button -->
      <button
        type="button"
        class="unlock-close-btn"
        (click)="onDismiss()"
        aria-label="Close celebration"
      >
        ✕
      </button>

      <!-- Celebration Header Banner -->
      <div class="unlock-celebration-badge">
        <span class="celebration-sparkle">✨</span>
        <span class="celebration-text">ACHIEVEMENT UNLOCKED!</span>
        <span class="celebration-sparkle">✨</span>
      </div>

      <!-- Category & Tier Header Pills -->
      <div class="unlock-header-pills">
        <div class="unlock-category-pill" [ngClass]="categoryThemeKey">
          {{ categoryLabel }}
        </div>
        <div class="unlock-tier-pill" [ngClass]="'tier-' + tier.key">
          {{ tier.emoji }} {{ tier.name }} Tier
        </div>
        @if (totalCount > 1) {
          <div class="unlock-queue-pill">
            <span>{{ currentIndex }} of {{ totalCount }}</span>
          </div>
        }
      </div>

      <!-- Center Shield Badge -->
      <div class="unlock-shield-container">
        <div class="shield-wrapper modal-shield">
          <svg
            class="shield-svg shield-earned"
            [ngClass]="'shield-tier-' + tier.key"
            viewBox="0 0 80 90"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <!-- Saturated luxury metallic / gemstone gradient -->
              <linearGradient
                [id]="'unlock-sg-' + activeAchievement.id"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                @for (stop of tier.gradientStops; track stop.offset) {
                  <stop
                    [attr.offset]="stop.offset"
                    [attr.stop-color]="stop.color"
                    [style.stop-color]="stop.color"
                  />
                }
              </linearGradient>

              <!-- 3D Beveled rim frame gradient -->
              <linearGradient
                [id]="'unlock-rim-' + activeAchievement.id"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop offset="0%" [attr.stop-color]="tier.rimColor" />
                <stop offset="100%" [attr.stop-color]="tier.accentColor" />
              </linearGradient>
            </defs>

            <!-- Outer Shield Bezel Frame -->
            <path
              d="M40 4 L76 15 L76 48 C76 66 58 82 40 88 C22 82 4 66 4 48 L4 15 Z"
              [attr.fill]="'url(#unlock-rim-' + activeAchievement.id + ')'"
            />

            <!-- Inner Shield Main Plate -->
            <path
              d="M40 8.5 L71.5 18.5 L71.5 47 C71.5 62 55.5 76 40 82 C24.5 76 8.5 62 8.5 47 L8.5 18.5 Z"
              [attr.fill]="'url(#unlock-sg-' + activeAchievement.id + ')'"
            />

            <!-- Subtle Right Facet Shadow for Sharp 3D Definition -->
            <path
              d="M40 8.5 L71.5 18.5 L71.5 47 C71.5 62 55.5 76 40 82 Z"
              fill="rgba(0, 0, 0, 0.07)"
            />

            <!-- Icon for achievement -->
            <g class="shield-badge-icon">
              <svg
                x="26"
                y="27"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                @switch (iconKey) {
                  @case ("first-signal") {
                    <!-- House Signal Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M547.9 304L528 304L528 448C528 483.3 499.3 512 464 512L327 512C303 420.3 233.5 347 144 317.7L144 304L124.1 304C108.6 304 96 291.4 96 275.9C96 268.3 99.1 261 104.6 255.7L308.5 59.1C315.9 52 325.7 48 336 48C346.3 48 356.1 52 363.5 59.1L567.4 255.7C572.9 261 576 268.3 576 275.9C576 291.4 563.4 304 547.9 304zM312 256C298.7 256 288 266.7 288 280L288 328C288 341.3 298.7 352 312 352L360 352C373.3 352 384 341.3 384 328L384 280C384 266.7 373.3 256 360 256L312 256zM56 352C184.1 352 288 455.9 288 584C288 597.3 277.3 608 264 608C250.7 608 240 597.3 240 584C240 482.4 157.6 400 56 400C42.7 400 32 389.3 32 376C32 362.7 42.7 352 56 352zM64 544C81.7 544 96 558.3 96 576C96 593.7 81.7 608 64 608C46.3 608 32 593.7 32 576C32 558.3 46.3 544 64 544zM32 472C32 458.7 42.7 448 56 448C131.1 448 192 508.9 192 584C192 597.3 181.3 608 168 608C154.7 608 144 597.3 144 584C144 535.4 104.6 496 56 496C42.7 496 32 485.3 32 472z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("lead-scout") {
                    <!-- Scout Compass -->
                    <circle cx="12" cy="12" r="9" />
                    <polygon
                      points="12,5 14.5,12 12,10.5 9.5,12"
                      fill="rgba(255,255,255,0.95)"
                      stroke="none"
                    />
                    <polygon
                      points="12,19 14.5,12 12,13.5 9.5,12"
                      fill="rgba(255,255,255,0.4)"
                      stroke="none"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="1.5"
                      fill="rgba(255,255,255,0.95)"
                    />
                    <line x1="12" y1="3" x2="12" y2="4.5" />
                    <line x1="12" y1="19.5" x2="12" y2="21" />
                    <line x1="3" y1="12" x2="4.5" y2="12" />
                    <line x1="19.5" y1="12" x2="21" y2="12" />
                  }
                  @case ("pipeline-builder") {
                    <!-- Pipeline Network Nodes -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M176 168C189.3 168 200 157.3 200 144C200 130.7 189.3 120 176 120C162.7 120 152 130.7 152 144C152 157.3 162.7 168 176 168zM256 144C256 176.8 236.3 205 208 217.3L208 240C208 266.5 229.5 288 256 288L384 288C410.5 288 432 266.5 432 240L432 217.3C403.7 205 384 176.8 384 144C384 99.8 419.8 64 464 64C508.2 64 544 99.8 544 144C544 176.8 524.3 205 496 217.3L496 240C496 301.9 445.9 352 384 352L352 352L352 422.7C380.3 435 400 463.2 400 496C400 540.2 364.2 576 320 576C275.8 576 240 540.2 240 496C240 463.2 259.7 435 288 422.7L288 352L256 352C194.1 352 144 301.9 144 240L144 217.3C115.7 205 96 176.8 96 144C96 99.8 131.8 64 176 64C220.2 64 256 99.8 256 144zM464 168C477.3 168 488 157.3 488 144C488 130.7 477.3 120 464 120C450.7 120 440 130.7 440 144C440 157.3 450.7 168 464 168zM344 496C344 482.7 333.3 472 320 472C306.7 472 296 482.7 296 496C296 509.3 306.7 520 320 520C333.3 520 344 509.3 344 496z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("community-connector") {
                    <!-- Community Users & Connections -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M31 31C21.7 40.4 21.7 55.6 31 65L87 121C96.4 130.4 111.6 130.4 120.9 121C130.2 111.6 130.3 96.4 120.9 87.1L65 31C55.6 21.6 40.4 21.6 31.1 31zM609 31C599.6 21.6 584.4 21.6 575.1 31L519 87C509.6 96.4 509.6 111.6 519 120.9C528.4 130.2 543.6 130.3 552.9 120.9L609 65C618.4 55.6 618.4 40.4 609 31.1zM65 609L121 553C130.4 543.6 130.4 528.4 121 519.1C111.6 509.8 96.4 509.7 87.1 519.1L31 575C21.6 584.4 21.6 599.6 31 608.9C40.4 618.2 55.6 618.3 64.9 608.9zM609 609C618.4 599.6 618.4 584.4 609 575.1L553 519.1C543.6 509.7 528.4 509.7 519.1 519.1C509.8 528.5 509.7 543.7 519.1 553L575.1 609C584.5 618.4 599.7 618.4 609 609zM320 272C355.3 272 384 243.3 384 208C384 172.7 355.3 144 320 144C284.7 144 256 172.7 256 208C256 243.3 284.7 272 320 272zM320 304C258.1 304 208 354.1 208 416L208 424C208 437.3 218.7 448 232 448L408 448C421.3 448 432 437.3 432 424L432 416C432 354.1 381.9 304 320 304zM536 224C536 193.1 510.9 168 480 168C449.1 168 424 193.1 424 224C424 254.9 449.1 280 480 280C510.9 280 536 254.9 536 224zM451.2 324.4C469.4 350.3 480 381.9 480 416L480 424C480 432.4 478.6 440.5 475.9 448L554.7 448C566.5 448 576 438.4 576 426.7L576 416C576 363 533 320 480 320C470 320 460.3 321.5 451.2 324.4zM188.8 324.4C179.7 321.5 170 320 160 320C107 320 64 363 64 416L64 426.7C64 438.5 73.6 448 85.3 448L164.1 448C161.4 440.5 160 432.4 160 424L160 416C160 381.9 170.6 350.3 188.8 324.4zM216 224C216 193.1 190.9 168 160 168C129.1 168 104 193.1 104 224C104 254.9 129.1 280 160 280C190.9 280 216 254.9 216 224z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("opportunity-engine") {
                    <!-- Opportunity Engine Gears -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M415.9 274.5C428.1 271.2 440.9 277 446.4 288.3L465 325.9C475.3 327.3 485.4 330.1 494.9 334L529.9 310.7C540.4 303.7 554.3 305.1 563.2 314L582.4 333.2C591.3 342.1 592.7 356.1 585.7 366.5L562.4 401.4C564.3 406.1 566 411 567.4 416.1C568.8 421.2 569.7 426.2 570.4 431.3L608.1 449.9C619.4 455.5 625.2 468.3 621.9 480.4L614.9 506.6C611.6 518.7 600.3 526.9 587.7 526.1L545.7 523.4C539.4 531.5 532.1 539 523.8 545.4L526.5 587.3C527.3 599.9 519.1 611.3 507 614.5L480.8 621.5C468.6 624.8 455.9 619 450.3 607.7L431.7 570.1C421.4 568.7 411.3 565.9 401.8 562L366.8 585.3C356.3 592.3 342.4 590.9 333.5 582L314.3 562.8C305.4 553.9 304 540 311 529.5L334.3 494.5C332.4 489.8 330.7 484.9 329.3 479.8C327.9 474.7 327 469.6 326.3 464.6L288.6 446C277.3 440.4 271.6 427.6 274.8 415.5L281.8 389.3C285.1 377.2 296.4 369 309 369.8L350.9 372.5C357.2 364.4 364.5 356.9 372.8 350.5L370.1 308.7C369.3 296.1 377.5 284.7 389.6 281.5L415.8 274.5zM448.4 404C424.1 404 404.4 423.7 404.5 448.1C404.5 472.4 424.2 492 448.5 492C472.8 492 492.5 472.3 492.5 448C492.4 423.6 472.7 404 448.4 404zM224.9 18.5L251.1 25.5C263.2 28.8 271.4 40.2 270.6 52.7L267.9 94.5C276.2 100.9 283.5 108.3 289.8 116.5L331.8 113.8C344.3 113 355.7 121.2 359 133.3L366 159.5C369.2 171.6 363.5 184.4 352.2 190L314.5 208.6C313.8 213.7 312.8 218.8 311.5 223.8C310.2 228.8 308.4 233.8 306.5 238.5L329.8 273.5C336.8 284 335.4 297.9 326.5 306.8L307.3 326C298.4 334.9 284.5 336.3 274 329.3L239 306C229.5 309.9 219.4 312.7 209.1 314.1L190.5 351.7C184.9 363 172.1 368.7 160 365.5L133.8 358.5C121.6 355.2 113.5 343.8 114.3 331.3L117 289.4C108.7 283 101.4 275.6 95.1 267.4L53.1 270.1C40.6 270.9 29.2 262.7 25.9 250.6L18.9 224.4C15.7 212.3 21.4 199.5 32.7 193.9L70.4 175.3C71.1 170.2 72.1 165.2 73.4 160.1C74.8 155 76.4 150.1 78.4 145.4L55.1 110.5C48.1 100 49.5 86.1 58.4 77.2L77.6 58C86.5 49.1 100.4 47.7 110.9 54.7L145.9 78C155.4 74.1 165.5 71.3 175.8 69.9L194.4 32.3C200 21 212.7 15.3 224.9 18.5zM192.4 148C168.1 148 148.4 167.7 148.4 192C148.4 216.3 168.1 236 192.4 236C216.7 236 236.4 216.3 236.4 192C236.4 167.7 216.7 148 192.4 148z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("capital-catalyst") {
                    <!-- Lightning / Catalyst Energy -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M128 320L156.5 92C158.5 76 172.1 64 188.3 64L356.9 64C371.9 64 384 76.1 384 91.1C384 94.3 383.4 97.6 382.3 100.6L336 224L475.3 224C495.5 224 512 240.4 512 260.7C512 268.1 509.8 275.3 505.6 281.4L313.4 562.4C307.5 571 297.8 576.1 287.5 576.1L284.6 576.1C268.9 576.1 256.1 563.3 256.1 547.6C256.1 545.3 256.4 543 257 540.7L304 352L160 352C142.3 352 128 337.7 128 320z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("claim-the-quest") {
                    <!-- Quest Pennant Flag -->
                    <line x1="5" y1="3" x2="5" y2="21" />
                    <path
                      d="M5 4 H18 L14 9 L18 14 H5 Z"
                      fill="rgba(255,255,255,0.95)"
                    />
                    <circle cx="5" cy="3" r="1" fill="rgba(255,255,255,0.95)" />
                  }
                  @case ("deal-runner") {
                    <!-- Deal Handshake / Runner Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M300.9 149.2L184.3 278.8C179.7 283.9 179.9 291.8 184.8 296.7C215.3 327.2 264.8 327.2 295.3 296.7L327.1 264.9C331.3 260.7 336.6 258.4 342 258C348.8 257.4 355.8 259.7 361 264.9L537.6 440L608 384L608 96L496 160L472.2 144.1C456.4 133.6 437.9 128 418.9 128L348.5 128C347.4 128 346.2 128 345.1 128.1C328.2 129 312.3 136.6 300.9 149.2zM148.6 246.7L255.4 128L215.8 128C190.3 128 165.9 138.1 147.9 156.1L144 160L32 96L32 384L188.4 514.3C211.4 533.5 240.4 544 270.3 544L286 544L279 537C269.6 527.6 269.6 512.4 279 503.1C288.4 493.8 303.6 493.7 312.9 503.1L353.9 544.1L362.9 544.1C382 544.1 400.7 539.8 417.7 531.8L391 505C381.6 495.6 381.6 480.4 391 471.1C400.4 461.8 415.6 461.7 424.9 471.1L456.9 503.1L474.4 485.6C483.3 476.7 485.9 463.8 482 452.5L344.1 315.7L329.2 330.6C279.9 379.9 200.1 379.9 150.8 330.6C127.8 307.6 126.9 270.7 148.6 246.6z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("mission-control") {
                    <!-- Radar / Target Navigation -->
                    <circle cx="12" cy="12" r="8" />
                    <circle cx="12" cy="12" r="4" />
                    <circle
                      cx="12"
                      cy="12"
                      r="1.5"
                      fill="rgba(255,255,255,0.95)"
                    />
                    <line x1="12" y1="2" x2="12" y2="5" />
                    <line x1="12" y1="19" x2="12" y2="22" />
                    <line x1="2" y1="12" x2="5" y2="12" />
                    <line x1="19" y1="12" x2="22" y2="12" />
                  }
                  @case ("assignment-ace") {
                    <!-- Authentic Playing Card Ace of Spades -->
                    <rect
                      x="4.5"
                      y="2.5"
                      width="15"
                      height="19"
                      rx="2"
                      stroke-width="1.8"
                    />
                    <!-- Top-left Ace 'A' -->
                    <path
                      d="M6.8 8.5 L8.1 5.5 L9.4 8.5 M7.2 7.6 H9"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <!-- Center Bold Ace of Spades -->
                    <path
                      d="M12 7.2 C10.2 9.8 8.2 11.4 8.2 13.2 C8.2 14.7 9.4 15.6 10.8 15.6 C11.6 15.6 12 15 12 14.4 C12 15 12.4 15.6 13.2 15.6 C14.6 15.6 15.8 14.7 15.8 13.2 C15.8 11.4 13.8 9.8 12 7.2 Z"
                      fill="rgba(255,255,255,0.95)"
                      stroke="none"
                    />
                    <path
                      d="M12 14.2 L10.8 17 H13.2 Z"
                      fill="rgba(255,255,255,0.95)"
                      stroke="none"
                    />
                    <!-- Bottom-right Ace 'A' -->
                    <path
                      d="M14.6 18.5 L15.9 15.5 L17.2 18.5 M15 17.6 H16.8"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  }
                  @case ("flow-master") {
                    <!-- Water Waves / Flow Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M474.6 188.1C495.3 203.7 520.6 218.8 548.8 222.6C561.9 224.4 574 215.1 575.8 202C577.6 188.9 568.3 176.8 555.2 175C539.3 172.9 522 163.7 503.5 149.8C465.1 120.8 413 120.8 374.5 149.8C350.5 167.9 333.8 176.1 320 176.1C306.2 176.1 289.5 167.9 265.5 149.8C227.1 120.8 175 120.8 136.5 149.8C118 163.7 100.7 172.9 84.8 175C71.7 176.8 62.4 188.8 64.2 202C66 215.2 78 224.4 91.2 222.6C119.4 218.8 144.8 203.7 165.4 188.1C186.7 172 215.3 172 236.6 188.1C260.8 206.4 288.9 224 320 224C351.1 224 379.1 206.3 403.4 188.1C424.7 172 453.3 172 474.6 188.1zM474.6 332.1C495.3 347.7 520.6 362.8 548.8 366.6C561.9 368.4 574 359.1 575.8 346C577.6 332.9 568.3 320.8 555.2 319C539.3 316.9 522 307.7 503.5 293.8C465.1 264.8 413 264.8 374.5 293.8C350.5 311.9 333.8 320.1 320 320.1C306.2 320.1 289.5 311.9 265.5 293.8C227.1 264.8 175 264.8 136.5 293.8C118 307.7 100.7 316.9 84.8 319C71.7 320.7 62.4 332.8 64.2 346C66 359.2 78 368.4 91.2 366.6C119.4 362.8 144.8 347.7 165.4 332.1C186.7 316 215.3 316 236.6 332.1C260.8 350.4 288.9 368 320 368C351.1 368 379.1 350.3 403.4 332.1C424.7 316 453.3 316 474.6 332.1zM403.4 476.1C424.7 460 453.3 460 474.6 476.1C495.3 491.7 520.6 506.8 548.8 510.6C561.9 512.4 574 503.1 575.8 490C577.6 476.9 568.3 464.8 555.2 463C539.3 460.9 522 451.7 503.5 437.8C465.1 408.8 413 408.8 374.5 437.8C350.5 455.9 333.8 464.1 320 464.1C306.2 464.1 289.5 455.9 265.5 437.8C227.1 408.8 175 408.8 136.5 437.8C118 451.7 100.7 460.9 84.8 463C71.7 464.8 62.4 476.8 64.2 490C66 503.2 78 512.4 91.2 510.6C119.4 506.8 144.8 491.7 165.4 476.1C186.7 460 215.3 460 236.6 476.1C260.8 494.4 288.9 512 320 512C351.1 512 379.1 494.3 403.4 476.1z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("status-check") {
                    <!-- Clipboard Check -->
                    <rect x="5" y="4" width="14" height="17" rx="2" />
                    <path
                      d="M9 4 A1 1 0 0 1 10 3 H14 A1 1 0 0 1 15 4 V5 H9 V4 Z"
                      fill="rgba(255,255,255,0.95)"
                    />
                    <polyline
                      points="8.5,12.5 11,15 15.5,10"
                      stroke-width="2"
                    />
                  }
                  @case ("signal-keeper") {
                    <!-- Signal Strength Bars Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M552 120C552 106.7 541.3 96 528 96C514.7 96 504 106.7 504 120L504 520C504 533.3 514.7 544 528 544C541.3 544 552 533.3 552 520L552 120zM424 192C410.7 192 400 202.7 400 216L400 520C400 533.3 410.7 544 424 544C437.3 544 448 533.3 448 520L448 216C448 202.7 437.3 192 424 192zM344 312C344 298.7 333.3 288 320 288C306.7 288 296 298.7 296 312L296 520C296 533.3 306.7 544 320 544C333.3 544 344 533.3 344 520L344 312zM216 384C202.7 384 192 394.7 192 408L192 520C192 533.3 202.7 544 216 544C229.3 544 240 533.3 240 520L240 408C240 394.7 229.3 384 216 384zM112 448C98.7 448 88 458.7 88 472L88 520C88 533.3 98.7 544 112 544C125.3 544 136 533.3 136 520L136 472C136 458.7 125.3 448 112 448z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("pipeline-pulse") {
                    <!-- Heartbeat Pulse -->
                    <circle cx="12" cy="12" r="9" />
                    <path
                      d="M3 12 H7 L9.5 6.5 L13 17.5 L15.5 10.5 L17.5 12 H21"
                      stroke-width="2"
                    />
                  }
                  @case ("data-steward") {
                    <!-- Data Steward Database Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M544 269.8C529.2 279.6 512.2 287.5 494.5 293.8C447.5 310.6 385.8 320 320 320C254.2 320 192.4 310.5 145.5 293.8C127.9 287.5 110.8 279.6 96 269.8L96 352C96 396.2 196.3 432 320 432C443.7 432 544 396.2 544 352L544 269.8zM544 192L544 144C544 99.8 443.7 64 320 64C196.3 64 96 99.8 96 144L96 192C96 236.2 196.3 272 320 272C443.7 272 544 236.2 544 192zM494.5 453.8C447.6 470.5 385.9 480 320 480C254.1 480 192.4 470.5 145.5 453.8C127.9 447.5 110.8 439.6 96 429.8L96 496C96 540.2 196.3 576 320 576C443.7 576 544 540.2 544 496L544 429.8C529.2 439.6 512.2 447.5 494.5 453.8z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("source-of-truth") {
                    <!-- Source of Truth Document Shield Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M128 64C92.7 64 64 92.7 64 128L64 512C64 547.3 92.7 576 128 576L329.2 576C293 533.4 272 478.5 272 420.4L272 389.3C272 354.9 294 324.3 326.7 313.4L438.7 276.1C441.8 275.1 444.9 274.3 448 273.6L448 234.5C448 217.5 441.3 201.2 429.3 189.2L322.7 82.7C310.7 70.7 294.5 64 277.5 64L128 64zM389.5 240L296 240C282.7 240 272 229.3 272 216L272 122.5L389.5 240zM477.3 552.5L464 558.8L464 370.7L560 402.7L560 422.3C560 478.1 527.8 528.8 477.3 552.6zM453.9 323.5L341.9 360.8C328.8 365.2 320 377.4 320 391.2L320 422.3C320 496.7 363 564.4 430.2 596L448.7 604.7C453.5 606.9 458.7 608.1 463.9 608.1C469.1 608.1 474.4 606.9 479.1 604.7L497.6 596C565 564.3 608 496.6 608 422.2L608 391.1C608 377.3 599.2 365.1 586.1 360.7L474.1 323.4C467.5 321.2 460.4 321.2 453.9 323.4z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("first-close") {
                    <!-- First Close Coin Vault Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M128 288C128 182 214 96 320 96C426 96 512 182 512 288C512 394 426 480 320 480C214 480 128 394 128 288zM304 196L304 200C275.2 200.3 252 223.7 252 252.5C252 278.2 270.5 300.1 295.9 304.3L337.6 311.3C343.6 312.3 348 317.5 348 323.6C348 330.5 342.4 336.1 335.5 336.1L280 336C269 336 260 345 260 356C260 367 269 376 280 376L304 376L304 380C304 391 313 400 324 400C335 400 344 391 344 380L344 375.3C369 371.2 388 349.6 388 323.5C388 297.8 369.5 275.9 344.1 271.7L302.4 264.7C296.4 263.7 292 258.5 292 252.4C292 245.5 297.6 239.9 304.5 239.9L352 239.9C363 239.9 372 230.9 372 219.9C372 208.9 363 199.9 352 199.9L344 199.9L344 195.9C344 184.9 335 175.9 324 175.9C313 175.9 304 184.9 304 195.9zM80 408L80 512C80 520.8 87.2 528 96 528L544 528C552.8 528 560 520.8 560 512L560 408C560 394.7 570.7 384 584 384C597.3 384 608 394.7 608 408L608 512C608 547.3 579.3 576 544 576L96 576C60.7 576 32 547.3 32 512L32 408C32 394.7 42.7 384 56 384C69.3 384 80 394.7 80 408z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("capital-deployed") {
                    <!-- Capital Deployed Money Bag Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M392 176L248 176L210.7 101.5C208.9 97.9 208 93.9 208 89.9C208 75.6 219.6 64 233.9 64L406.1 64C420.4 64 432 75.6 432 89.9C432 93.9 431.1 97.9 429.3 101.5L392 176zM233.6 224L406.4 224L455.1 264.6C521.6 320 560 402 560 488.5C560 536.8 520.8 576 472.5 576L167.4 576C119.2 576 80 536.8 80 488.5C80 402 118.4 320 184.9 264.6L233.6 224zM324 288C313 288 304 297 304 308L304 312C275.2 312.3 252 335.7 252 364.5C252 390.2 270.5 412.1 295.9 416.3L337.6 423.3C343.6 424.3 348 429.5 348 435.6C348 442.5 342.4 448.1 335.5 448.1L280 448C269 448 260 457 260 468C260 479 269 488 280 488L304 488L304 492C304 503 313 512 324 512C335 512 344 503 344 492L344 487.3C369 483.2 388 461.6 388 435.5C388 409.8 369.5 387.9 344.1 383.7L302.4 376.7C296.4 375.7 292 370.5 292 364.4C292 357.5 297.6 351.9 304.5 351.9L352 351.9C363 351.9 372 342.9 372 331.9C372 320.9 363 311.9 352 311.9L344 311.9L344 307.9C344 296.9 335 287.9 324 287.9z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("impact-maker") {
                    <!-- Impact Maker Coin in Hand Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M320 48C306.7 48 296 58.7 296 72L296 84L294.2 84C257.6 84 228 113.7 228 150.2C228 183.6 252.9 211.8 286 215.9L347 223.5C352.1 224.1 356 228.5 356 233.7C356 239.4 351.4 243.9 345.8 243.9L272 244C256.5 244 244 256.5 244 272C244 287.5 256.5 300 272 300L296 300L296 312C296 325.3 306.7 336 320 336C333.3 336 344 325.3 344 312L344 300L345.8 300C382.4 300 412 270.3 412 233.8C412 200.4 387.1 172.2 354 168.1L293 160.5C287.9 159.9 284 155.5 284 150.3C284 144.6 288.6 140.1 294.2 140.1L360 140C375.5 140 388 127.5 388 112C388 96.5 375.5 84 360 84L344 84L344 72C344 58.7 333.3 48 320 48zM141.3 405.5L98.7 448L64 448C46.3 448 32 462.3 32 480L32 544C32 561.7 46.3 576 64 576L384.5 576C413.5 576 441.8 566.7 465.2 549.5L591.8 456.2C609.6 443.1 613.4 418.1 600.3 400.3C587.2 382.5 562.2 378.7 544.4 391.8L424.6 480L312 480C298.7 480 288 469.3 288 456C288 442.7 298.7 432 312 432L384 432C401.7 432 416 417.7 416 400C416 382.3 401.7 368 384 368L231.8 368C197.9 368 165.3 381.5 141.3 405.5z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("deal-champion") {
                    <!-- Deal Champion Growth & Banknote Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M544 72C544 58.7 533.3 48 520 48L418.2 48C404.9 48 394.2 58.7 394.2 72C394.2 85.3 404.9 96 418.2 96L462.1 96L350.8 207.3L255.7 125.8C246.7 118.1 233.5 118.1 224.5 125.8L112.5 221.8C102.4 230.4 101.3 245.6 109.9 255.6C118.5 265.6 133.7 266.8 143.7 258.2L240.1 175.6L336.5 258.2C346 266.4 360.2 265.8 369.1 256.9L496.1 129.9L496.1 173.8C496.1 187.1 506.8 197.8 520.1 197.8C533.4 197.8 544.1 187.1 544.1 173.8L544 72zM112 320C85.5 320 64 341.5 64 368L64 528C64 554.5 85.5 576 112 576L528 576C554.5 576 576 554.5 576 528L576 368C576 341.5 554.5 320 528 320L112 320zM159.3 376C155.9 396.1 140.1 412 119.9 415.4C115.5 416.1 111.9 412.5 111.9 408.1L111.9 376.1C111.9 371.7 115.5 368.1 119.9 368.1L151.9 368.1C156.3 368.1 160 371.7 159.2 376.1zM159.3 520.1C160 524.5 156.4 528.1 152 528.1L120 528.1C115.6 528.1 112 524.5 112 520.1L112 488.1C112 483.7 115.6 480 120 480.8C140.1 484.2 156 500 159.4 520.2zM520 480.7C524.4 480 528 483.6 528 488L528 520C528 524.4 524.4 528 520 528L488 528C483.6 528 479.9 524.4 480.7 520C484.1 499.9 499.9 484 520.1 480.6zM480.7 376C480 371.6 483.6 368 488 368L520 368C524.4 368 528 371.6 528 376L528 408C528 412.4 524.4 416.1 520 415.3C499.9 411.9 484 396.1 480.6 375.9zM256 448C256 412.7 284.7 384 320 384C355.3 384 384 412.7 384 448C384 483.3 355.3 512 320 512C284.7 512 256 483.3 256 448z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("funding-legend") {
                    <!-- Funding Legend Credit Card / Bank Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M128 128C92.7 128 64 156.7 64 192L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 192C576 156.7 547.3 128 512 128L128 128zM360 352L488 352C501.3 352 512 362.7 512 376C512 389.3 501.3 400 488 400L360 400C346.7 400 336 389.3 336 376C336 362.7 346.7 352 360 352zM336 264C336 250.7 346.7 240 360 240L488 240C501.3 240 512 250.7 512 264C512 277.3 501.3 288 488 288L360 288C346.7 288 336 277.3 336 264zM212 208C223 208 232 217 232 228L232 232L240 232C251 232 260 241 260 252C260 263 251 272 240 272L192.5 272C185.6 272 180 277.6 180 284.5C180 290.6 184.4 295.8 190.4 296.8L232.1 303.8C257.4 308 276 329.9 276 355.6C276 381.7 257 403.3 232 407.4L232 412.1C232 423.1 223 432.1 212 432.1C201 432.1 192 423.1 192 412.1L192 408.1L168 408.1C157 408.1 148 399.1 148 388.1C148 377.1 157 368.1 168 368.1L223.5 368.1C230.4 368.1 236 362.5 236 355.6C236 349.5 231.6 344.3 225.6 343.3L183.9 336.3C158.5 332 140 310.1 140 284.5C140 255.7 163.2 232.3 192 232L192 228C192 217 201 208 212 208z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("open-the-door") {
                    <!-- Open The Door Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M384 128L448 128L448 544C448 561.7 462.3 576 480 576L512 576C529.7 576 544 561.7 544 544C544 526.3 529.7 512 512 512L512 128C512 92.7 483.3 64 448 64L352 64L352 64L192 64C156.7 64 128 92.7 128 128L128 512C110.3 512 96 526.3 96 544C96 561.7 110.3 576 128 576L352 576C369.7 576 384 561.7 384 544L384 128zM256 320C256 302.3 270.3 288 288 288C305.7 288 320 302.3 320 320C320 337.7 305.7 352 288 352C270.3 352 256 337.7 256 320z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("network-pass") {
                    <!-- Network Pass Identification / Badge Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M128 128C128 92.7 156.7 64 192 64L448 64C483.3 64 512 92.7 512 128L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM224 472C224 485.3 234.7 496 248 496L392 496C405.3 496 416 485.3 416 472C416 458.7 405.3 448 392 448L248 448C234.7 448 224 458.7 224 472zM406.6 272C401.8 298.4 385.1 320.7 362.4 333.2C369.1 316.2 373.6 295.2 375 272L406.6 272zM233.5 272L265.1 272C266.5 295.1 271.1 316.2 277.7 333.2C255 320.7 238.3 298.4 233.5 272zM309.9 327C303.7 313.6 298.8 294.5 297.2 272L343 272C341.4 294.5 336.5 313.6 330.3 327C325.8 336.6 322.1 340.8 320.1 342.5C318.1 340.8 314.4 336.7 309.9 327zM309.9 185C314.4 175.4 318.1 171.2 320.1 169.5C322.1 171.2 325.8 175.3 330.3 185C336.5 198.4 341.4 217.5 343 240L297.2 240C298.8 217.5 303.7 198.4 309.9 185zM406.6 240L375 240C373.6 216.9 369 195.8 362.4 178.8C385.1 191.3 401.8 213.6 406.6 240zM265 240L233.4 240C238.2 213.6 254.9 191.3 277.6 178.8C270.9 195.8 266.4 216.8 265 240zM448 256C448 185.3 390.7 128 320 128C249.3 128 192 185.3 192 256C192 326.7 249.3 384 320 384C390.7 384 448 326.7 448 256z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("bridge-builder") {
                    <!-- Bridge Builder Verified Bridge Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M64 96C46.3 96 32 110.3 32 128C32 145.7 46.3 160 64 160L72 160L72 224L32 224L32 336C69.6 345.4 96 379.2 96 418L96 512C96 529.7 110.3 544 128 544L160 544C177.7 544 192 529.7 192 512L192 448C192 395 235 352 288 352C294.4 352 300.7 352.6 306.7 353.8C341.4 304.3 398.9 272 464 272C492.6 272 519.6 278.2 544 289.4L544 224L504 224L504 160L512 160C529.7 160 544 145.7 544 128C544 110.3 529.7 96 512 96L64 96zM456 160L456 224L376 224L376 160L456 160zM328 160L328 224L248 224L248 160L328 160zM120 160L200 160L200 224L120 224L120 160zM608 464C608 384.5 543.5 320 464 320C384.5 320 320 384.5 320 464C320 543.5 384.5 608 464 608C543.5 608 608 543.5 608 464zM521.4 403.1C528.5 408.3 530.1 418.3 524.9 425.4L460.9 513.4C458.1 517.2 453.9 519.6 449.2 519.9C444.5 520.2 439.9 518.6 436.6 515.3L396.6 475.3C390.4 469.1 390.4 458.9 396.6 452.7C402.8 446.5 413 446.5 419.2 452.7L446 479.5L499 406.6C504.2 399.5 514.2 397.9 521.4 403.1z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("second-look-specialist") {
                    <!-- Second Look Specialist Expanding Arrows Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M176 120C176 106.7 165.3 96 152 96C138.7 96 128 106.7 128 120L128 158.1L65 95.1C55.6 85.7 40.4 85.7 31.1 95.1C21.8 104.5 21.7 119.6 31 129L94 192L55.9 192C42.6 192 31.9 202.7 31.9 216C31.9 229.3 42.6 240 55.9 240L151.9 240C165.2 240 175.9 229.3 175.9 216L175.9 120zM176 520L176 424C176 410.7 165.3 400 152 400L56 400C42.7 400 32 410.7 32 424C32 437.3 42.7 448 56 448L94.1 448L31.1 511C21.7 520.4 21.7 535.6 31.1 544.9C40.5 554.2 55.7 554.3 65 544.9L128 481.9L128 520C128 533.3 138.7 544 152 544C165.3 544 176 533.3 176 520zM488 544C501.3 544 512 533.3 512 520L512 481.9L575 544.9C584.4 554.3 599.6 554.3 608.9 544.9C618.2 535.5 618.3 520.3 608.9 511L545.9 448L584 448C597.3 448 608 437.3 608 424C608 410.7 597.3 400 584 400L488 400C474.7 400 464 410.7 464 424L464 520C464 533.3 474.7 544 488 544zM464 120L464 216C464 229.3 474.7 240 488 240L584 240C597.3 240 608 229.3 608 216C608 202.7 597.3 192 584 192L545.9 192L608.9 129C618.3 119.6 618.3 104.4 608.9 95.1C599.5 85.8 584.3 85.7 575 95.1L512 158.1L512 120C512 106.7 501.3 96 488 96C474.7 96 464 106.7 464 120zM320 184C262.7 184 220.6 218 194.4 248.3C174.4 271.4 162 294.1 156.8 304.4C154.3 309.4 151.9 314.1 151.9 320C151.9 325.9 154.2 330.6 156.8 335.6C162 345.9 174.4 368.6 194.4 391.7C220.6 422 262.6 456 320 456C377.4 456 419.4 422 445.6 391.7C465.6 368.6 478 345.9 483.2 335.6C485.7 330.6 488.1 325.9 488.1 320C488.1 314.1 485.8 309.4 483.2 304.4C478 294.1 465.6 271.4 445.6 248.3C419.4 218 377.4 184 320 184zM256 320C256 284.7 284.7 256 320 256C355.3 256 384 284.7 384 320C384 355.3 355.3 384 320 384C284.7 384 256 355.3 256 320z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @case ("network-multiplier") {
                    <!-- Network Multiplier Power Nodes Icon -->
                    <svg
                      viewBox="0 0 640 640"
                      width="24"
                      height="24"
                      x="0"
                      y="0"
                    >
                      <path
                        d="M280 170.6C298.9 161.6 312 142.3 312 120C312 89.1 286.9 64 256 64C225.1 64 200 89.1 200 120C200 142.3 213.1 161.6 232 170.6L232 269.4C229.2 270.7 226.5 272.3 224 274.1L143.9 228.3C145.5 207.5 135.3 186.7 116 175.5C89.2 160 55 169.2 39.5 196C24 222.8 33.2 257 60 272.5C61.3 273.3 62.6 274 64 274.6L64 365.4C62.7 366 61.3 366.7 60 367.5C33.2 383 24 417.2 39.5 444C55 470.8 89.2 480 116 464.5C135.3 453.4 145.4 432.5 143.8 411.7L194.3 382.8C182.8 371.6 174.4 357.2 170.5 341.1L120 370.1C117.4 368.3 114.8 366.8 112 365.4L112 274.6C114.8 273.3 117.5 271.7 120 269.9L200.1 315.7C200 317.1 199.9 318.5 199.9 320C199.9 342.3 213 361.6 231.9 370.6L231.9 469.4C213 478.4 199.9 497.7 199.9 520C199.9 550.9 225 576 255.9 576C286.6 576 311.5 551.3 311.9 520.8C304.4 507.9 298.4 494 294.3 479.3C290.1 475.3 285.2 472 279.9 469.4L279.9 370.6C282.7 369.3 285.4 367.7 287.9 365.9L298.4 371.9C303.9 356.6 311.5 342.4 320.8 329.4L311.7 324.2C311.8 322.8 311.9 321.4 311.9 319.9C311.9 297.6 298.8 278.3 279.9 269.3L279.9 170.5zM472.5 196C457 169.2 422.8 160 396 175.5C376.7 186.6 366.6 207.5 368.2 228.3L317.6 257.2C329.1 268.4 337.5 282.8 341.4 298.9L392 269.9C392.4 270.2 392.8 270.5 393.3 270.8C415 261.3 438.9 256 464.1 256C466.1 256 468.1 256 470 256.1C482.1 238.8 483.8 215.5 472.6 196zM464 576C543.5 576 608 511.5 608 432C608 352.5 543.5 288 464 288C384.5 288 320 352.5 320 432C320 511.5 384.5 576 464 576zM511.9 351C516.2 354.7 517.3 360.9 514.5 365.9L484.4 420L520 420C525.2 420 529.8 423.3 531.4 428.2C533 433.1 531.3 438.5 527.2 441.6L431.2 513.6C426.7 517 420.4 516.8 416.1 513C411.8 509.2 410.7 503.1 413.5 498.1L443.6 444L408 444C402.8 444 398.2 440.7 396.6 435.8C395 430.9 396.7 425.5 400.8 422.4L496.8 350.4C501.3 347 507.6 347.2 511.9 351z"
                        fill="rgba(255,255,255,0.95)"
                        stroke="none"
                      />
                    </svg>
                  }
                  @default {
                    <!-- Prestige Medal -->
                    <polygon
                      points="12,3 14.5,8.5 20.5,9.5 16,13.5 17.5,19.5 12,16.5 6.5,19.5 8,13.5 3.5,9.5 9.5,8.5"
                      fill="rgba(255,255,255,0.95)"
                      stroke="rgba(255,255,255,0.3)"
                      stroke-width="0.5"
                    />
                  }
                }
              </svg>
            </g>
          </svg>

          <!-- Earned check badge -->
          <div class="earned-check" aria-label="Unlocked">
            <app-svg-icon
              [iconName]="'check-simple.svg'"
              [width]="'14px'"
              [height]="'14px'"
              [style.fill]="'#fff'"
            ></app-svg-icon>
          </div>
        </div>
      </div>

      <!-- Achievement Title -->
      <h2 class="unlock-title">{{ activeAchievement.title }}</h2>

      <!-- Milestone Status Pill -->
      <div class="unlock-milestone-pill">
        <span class="unlock-pill-check">✓</span>
        <span
          >Milestone Reached ({{ activeAchievement.milestone }}
          {{ activeAchievement.milestone === 1 ? "Action" : "Actions" }})</span
        >
      </div>

      <!-- Description -->
      <p class="unlock-description">{{ activeAchievement.description }}</p>

      <!-- Status Celebration Box -->
      <div class="unlock-status-box">
        <div class="unlock-status-header">
          <span class="status-icon">🏆</span>
          <span class="status-text">Congratulations!</span>
        </div>
        <div class="unlock-status-subtext">
          You have successfully unlocked the
          <strong>{{ tier.name }} Tier {{ activeAchievement.title }}</strong>
          badge in <em>{{ categoryLabel }}</em
          >!
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="unlock-actions">
        @if (hasMoreInQueue) {
          <button
            type="button"
            class="btn-unlock-primary"
            (click)="onNextOrClose()"
            aria-label="Next unlocked badge"
          >
            <span>Next Badge</span>
            <span class="btn-arrow">→</span>
          </button>
        } @else {
          <button
            type="button"
            class="btn-unlock-primary"
            (click)="onDismiss()"
            aria-label="Claim and close"
          >
            <span>Awesome!</span>
          </button>
        }

        <button
          type="button"
          class="btn-unlock-secondary"
          (click)="onViewAllAchievements()"
          aria-label="View all achievements"
        >
          <span>View All Achievements</span>
        </button>
      </div>
    </div>
  </div>
}
